import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { useApi, errorText } from "@/lib/api";
import { headline } from "@/components/settlement/headline";

const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export default function RecordSettlementDialog({ director, onClose, onDone }) {
  const api = useApi();
  const [date, setDate] = useState(today());
  const [ledger, setLedger] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (director) { setDate(today()); setLedger(false); } }, [director]);
  if (!director) return null;
  const h = headline(director.result);

  const submit = async () => {
    setBusy(true);
    try {
      await api("post", "/settlement/record", { director: director.id, date, add_ledger_row: ledger });
      toast.success(`Settlement recorded for ${director.name}`);
      onDone();
    } catch (e) { toast.error(errorText(e)); }
    setBusy(false);
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-card" data-testid="record-settlement-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">Record settlement — {director.name}</DialogTitle>
          <DialogDescription>{h.text}. This posts a director account entry that brings the balance to zero.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2"><Label>Payment date</Label><Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="font-mono" data-testid="record-settlement-date" /></div>
          <label className="flex items-start gap-3 text-sm border border-border p-3">
            <Checkbox checked={ledger} onCheckedChange={(v) => setLedger(!!v)} data-testid="record-settlement-ledger-checkbox" />
            <span>
              Also add a matching Ledger row
              <span className="block text-xs text-muted-foreground mt-1">
                Adds a Spent (or Received) row to the Ledger in the year of this date so the cash movement shows in Cashflow. It is
                tagged as a settlement and left out of the company net, so the director's balance still comes to zero.
              </span>
            </span>
          </label>
        </div>
        <DialogFooter><Button onClick={submit} disabled={busy || !date} data-testid="record-settlement-confirm">{busy ? "Recording…" : "Record settlement"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
